"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyDrinkMasterSchema = void 0;
exports.EnergyDrinkMasterSchema = {
    "$id": "https://www.redbull.com/schemas/master/energy-drinks.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EnergyDrinkMaster",
    "description": "Profile for an edition of the Red Bull Energy Drink e.g. Red Bull Winter Edition",
    "type": "object",
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "type": {
            "enum": [
                "rrn:master:energy-drinks"
            ],
            "type": "string"
        },
        "relationships": {
            "type": "object",
            "properties": {
                "translations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:energy-drinks"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                },
                "translatedFrom": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                },
                                "type": {
                                    "enum": [
                                        "rrn:content:energy-drinks"
                                    ],
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "draftTranslations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:energy-drinks"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "additionalProperties": false
        },
        "meta": {
            "type": "object",
            "properties": {
                "published": {
                    "type": "boolean"
                },
                "status": {
                    "type": "string"
                },
                "version": {
                    "type": "number"
                },
                "dateCreated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                },
                "dateUpdated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                }
            }
        }
    },
    "required": [
        "id",
        "type",
        "relationships",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,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